import React, { useEffect } from 'react';
import { toastManager } from './toastManager';
import { useToast, ToastContainer } from '../../components/AppLauncher/TabbedInterface/LauncherSpace/Toast';

/**
 * ToastBridge - Connects global toast manager to useToast hook
 * 
 * This component subscribes to the global toastManager and displays
 * toasts using the existing useToast hook. This allows the Parent API
 * to show toasts without needing direct access to React context.
 * 
 * Usage: Add this component at the App level (in App.js)
 */
export function ToastBridge() {
  const { toasts, toast, removeToast } = useToast();

  useEffect(() => {
    // Subscribe to global toast manager
    const unsubscribe = toastManager.subscribe((toastData) => {
      const { message, type, duration } = toastData;
      
      // Call appropriate toast method based on type
      switch (type) {
        case 'success':
          toast.success(message, duration);
          break;
        case 'error':
          toast.error(message, duration);
          break;
        case 'warning':
          toast.warning(message, duration);
          break;
        case 'info':
        default:
          toast.info(message, duration);
          break;
      }
    });

    // Cleanup subscription on unmount
    return unsubscribe;
  }, [toast]);

  // Render ToastContainer to display toasts
  return <ToastContainer toasts={toasts} removeToast={removeToast} />;
}

